import { Translator } from '@itarget/shared'

export function translate(text) {
  return Translator({ transRef: `translation.${text}` }).props.children
}
